import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import SearchableSelect from '../common/SearchableSelect';

const AccountForm = ({ onSubmit, accounts = [] }) => {
  const [formData, setFormData] = useState({ name: '', type: 'Bank', accountNumber: '', description: '', parentId: '' });
  const [isSubAccount, setIsSubAccount] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await onSubmit({
      ...formData,
      parentId: isSubAccount ? formData.parentId : null
    });
    if (success) {
      setFormData({ name: '', type: 'Bank', accountNumber: '', description: '', parentId: '' });
      setIsSubAccount(false);
    }
  };

  const parentOptions = accounts.map(acc => ({
    value: acc._id,
    label: acc.accountNumber ? `${acc.accountNumber} · ${acc.name}` : acc.name
  }));

  return (
    <Card border="0" className="bg-light shadow-sm">
      <Card.Body>
        <h6 className="card-title text-uppercase small font-weight-bold mb-3">
          Add Account
        </h6>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="small mb-2">
            <Form.Label className="mb-1">Account Number</Form.Label>
            <Form.Control 
              type="text" size="sm" className="border-primary"
              value={formData.accountNumber} 
              onChange={e => setFormData({...formData, accountNumber: e.target.value})}
              placeholder="e.g. 1001" 
            />
          </Form.Group>
          <Form.Group className="small mb-2">
            <Form.Label className="mb-1">Account Name</Form.Label>
            <Form.Control 
              type="text" size="sm" className="border-primary"
              value={formData.name} 
              onChange={e => setFormData({...formData, name: e.target.value})}
              placeholder="e.g. Chase Checking" 
              required 
            />
          </Form.Group>

          <Form.Group className="small mb-2 d-flex align-items-center">
            <Form.Check 
              type="checkbox"
              id="isSubAccountAdd"
              label="Is sub-account"
              checked={isSubAccount}
              onChange={e => {
                const checked = e.target.checked;
                setIsSubAccount(checked);
                if (!checked) {
                  setFormData({ ...formData, parentId: '' });
                }
              }}
              className="mr-2"
            />
          </Form.Group>

          {isSubAccount && (
            <Form.Group className="small mb-2">
              <Form.Label className="mb-1">Parent Account</Form.Label>
              <SearchableSelect 
                placeholder="Search and select parent..."
                value={formData.parentId}
                onChange={parentId => {
                  const parentAcc = accounts.find(a => a._id === parentId);
                  if (parentAcc) {
                    setFormData({
                      ...formData,
                      parentId,
                      type: parentAcc.type
                    });
                  } else {
                    setFormData({
                      ...formData,
                      parentId: ''
                    });
                  }
                }}
                options={parentOptions}
              />
            </Form.Group>
          )}

          <Form.Group className="small mb-3">
            <Form.Label className="mb-1">Type</Form.Label>
            <Form.Control 
              as="select" size="sm" className="border-primary"
              value={formData.type}
              onChange={e => setFormData({...formData, type: e.target.value})}
              disabled={isSubAccount && !!formData.parentId}
            >
              <optgroup label="Assets">
                <option value="Bank">Bank</option>
                <option value="Accounts receivable (A/R)">Accounts receivable (A/R)</option>
                <option value="Other Current Assets">Other Current Assets</option>
                <option value="Fixed Assets">Fixed Assets</option>
                <option value="Other Assets">Other Assets</option>
              </optgroup>
              <optgroup label="Liabilities">
                <option value="Credit Card">Credit Card</option>
                <option value="Accounts payable (A/P)">Accounts payable (A/P)</option>
                <option value="Other Current Liabilities">Other Current Liabilities</option>
                <option value="Long Term Liabilities">Long Term Liabilities</option>
              </optgroup>
              <optgroup label="Equity">
                <option value="Equity">Equity</option>
              </optgroup>
              <optgroup label="Income">
                <option value="Income">Income</option>
                <option value="Other Income">Other Income</option>
              </optgroup>
              <optgroup label="Expenses">
                <option value="Cost of Goods Sold">Cost of Goods Sold</option>
                <option value="Expenses">Expenses</option>
                <option value="Expense" style={{ display: 'none' }}>Expenses</option>
                <option value="Other Expense">Other Expense</option>
              </optgroup>
            </Form.Control>
          </Form.Group>
          <Button 
            type="submit" size="sm" block className="font-weight-bold shadow-sm"
            variant="primary"
          >
            <i className="fas fa-plus mr-1"></i> Add Account
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AccountForm;
